export function authHeader() {
    // return authorization header with jwt token
    let user = JSON.parse(localStorage.getItem('user_pro'));
    let admin = JSON.parse(localStorage.getItem('admin'));
    if (user && (user.token || user.data.token)) {
        return {
            "Content-Type":"application/json",
            "Accept":"*", 
            'Authorization': 'Bearer ' + (user.token || user.data.token),
        };
    }else  if (admin && admin.token) {
        return {
            "Content-Type":"application/json",
            "Accept":"*", 
            'Authorization': 'Bearer ' + admin.token 
        };
    } else {
        return {
            "Content-Type":"application/json",
            "Accept":"*",             
        };
    }
}

// User-only auth header - never falls back to admin token
export function userAuthHeader() {
    let user = JSON.parse(localStorage.getItem('user_pro'));
    if (user && (user.token || user.data.token)) {
        return {
            "Content-Type":"application/json",
            "Accept":"*", 
            'Authorization': 'Bearer ' + (user.token || user.data.token),
        };
    } else {
        return {
            "Content-Type":"application/json",
            "Accept":"*",             
        };
    }
}